






















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import signature from 'vue-signature';
import {
  RepairOrderViewModel,
  AttachmentInfoViewModel,
  AddAttachmentModel,
  PaymentDetailResponseViewModel,
  RoEmailViewModel,
  RepairOrderResponseViewModel,
  OpenRepairOrderViewModel,
  VoiceCallModel,
  CustomerUpdateViewModel,
} from '@/models/fixedops/repairorder';
import { MessageViewModel } from '@/models/telephony/message';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { AttachmentType } from '@/models/fixedops/attachment';
import { VFields } from '@/models/v-fields';
import { addAttachmentsFields, addCustomUploaderAttachmentFields } from '@/models/formly.fields';
import { FileHelper as _file } from '@/helper/file.helper';
import { NotificationHelper as _notification } from '@/helper/notifications.helper';
import { Lane, GetLaneSelectList } from '@/models/admin/lane';
import { PaymentTypeDialog, RoleType } from '@/helper/enum';
import { MetadataType, MetadataKeyIdentifier } from '@/enums/enums';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { NotificationType } from '@/helper/enum';
import {
  attachmentTypeService,
  repairOrderService,
  customerService,
  voiceCallService,
  paymentService,
  laneService,
  paymentReportService,
  blobStorageService,
} from '@/shared';
import { Utils } from '@/helper/utils';
import { IPaymentDialog } from '@/models/paymentDialog';
import { FileUploadDataViewModel, FileViewModel } from '@/Alynk.dtos';
import { IFileUploaderOption } from '@/models/fileUploader';

Vue.component('vueSignature', signature);
declare const generatePdf;

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    customerAddress: {
      get() {
        return (
          this.roDetails.customerStreetAddress1 +
          ' ' +
          this.roDetails.customerStreetAddress2
        );
      },
    },
    partSaleApprovedPaymentDetail: {
      get() {
        const partsalesPayment = this.roDetails.paymentDetail.paymentResponses.filter(
          (x) => x.status == 'Approved'
        );
        return partsalesPayment;
      },
    },
    isFormValid() {
      // this.showAddAttachmentPopup.action.disable = !this.form.$valid;
    },
  },
  components: {
    service: () => import('@/components/repairorder/detail.service.vue'),
    Grid: () => import('@/components/common/app.grid.vue'),
    AttachmentGrid: () =>
      import('@/components/repairorder/attachment.grid.vue'),
    SendEmail: () => import('@/components/repairorder/detail.sendmail.vue'),
    SendSignatureEmail: () =>
      import('@/components/repairorder/detail.sendSignatureRequest.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    CenposPayment: () => import('@/components/common/cenpos.payment.vue'),
    SquarePayment: () => import('@/components/common/square.payment.vue'),
    CloverPayment: () => import('@/components/common/clover.payment.vue'),
    SendMessage: () => import('@/components/common/send.message.vue'),
    CardAddressDetails: () =>
      import('@/components/common/cards.address.details.vue'),
    CloverCardAddressDetails: () => import('@/components/common/clovercards.address.details.vue'),
    PaymentDialog: () => import('@/components/common/payment.dialog.vue'),
    FileUpload: () => import('@/components/common//app.fileupload.v2.vue')
  },
})
export default class RepairOrderDetailPage extends Base {
  public snackbar: boolean = false;
  public snackbarText: string = '';
  public paymentDialog: boolean = false;

  public pagedPayments: PaymentDetailResponseViewModel[] = [];
  public roDeductablePayments: PaymentDetailResponseViewModel[] = [];

  public pagedTextLog: MessageViewModel[] = [];
  public paymentPagination = new PaginationModel('date', true);
  public videoLynkPagination = new PaginationModel('date', true);

  public roDeductablePagination = new PaginationModel('documentNumber', true);

  public textPagination = new PaginationModel('name');
  public lane: string = '';
  public roDetailLoading: boolean = false;
  public isLaneLoading: boolean = false;
  public isCardLoading: boolean = false;
  public showAddCardDetails: boolean = false;
  public showCloverAddCardDetails: boolean = false;
  public addCardCustomerKey = '';
  public selectedPaymentType: string = '';

  public isShowWarning: boolean = false;
  public warningMessage = '';

  public paymentLinkText: string = '';
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public lstCustomerEmails: string[] = [];
  public lstCustomerPhone: string[] = [];
  public isSendPaymentReceipt: boolean = true;

  public isCloverDialog: boolean = false;
  public isCloverConfigured: boolean = false;

  public creditCardTotalFee: number = 0;
  public creditCardTotalFeeWithouTax: number = 0;

  public displayTotalFee: number = 0;
  public displayTotalDueWithFee: number;
  public totalDueWithFee: number = 0;

  public constants: any = {
    roNumber: '',
    laneId: 0,
    cardId: '',
  };

  public videoLynk: any = {
    email: '',
    phone: '',
  };

  public healthApproval: any = {
    sendMode: '',
  };

  public approvalRequest: any = {
    isApproved: false,
    id: ''
  };

  public customerUpdateViewModel: CustomerUpdateViewModel = {
    cellPhone: '',
    businessPhone: '',
    phoneNumber: '',
    customerNumber: '',
    firstName: '',
    lastName: '',
  };
  public flags: any = {
    showAttachmentGrid: false,
    showCallGrid: false,
    showTextGrid: false,
    showPaymentGrid: false,
    paymentApproved: false,
    showSendEmailPopup: false,
    showSendSignatureEmailPopup: false,
    payOverPhone: false,
    touchStarted: false,
    isClosed: false,
    showDetails: false,
  };
  public cenposDialog: boolean = false;
  public sendMessageDialog: boolean = false;
  public cenposStatus: boolean = false;
  public currentUrl: string = '';
  public isDeductiblePayment: boolean = false;

  public squareDialog: boolean = false;
  public isBypassCreditCardFeeRole: boolean = false;
  public isOverrideCCFeeApplied: boolean = true;
  public bypassReason: string = "";

  // Dialogs
  public showAddAttachmentPopup: IDialogOption = {
    width: 750,
    title: this.$parent.$t(
      'repairOrderDetails.addAttachmentDialog.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t(
        'repairOrderDetails.addAttachmentDialog.btnSave'
      ) as string,
    },
    loading: false,
    onAction: (): void => {
      // this.saveAttachment();
      // this.uploadDialog.model = true;
      this.confirmUpload();
    },
  };
  public showEmailUpdatePopup: IDialogOption = {
    width: 600,
    title: this.$parent.$t(
      'repairOrderDetails.updateEmailDialog.title'
    ) as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t(
        'repairOrderDetails.updateEmailDialog.btnUpdate'
      ) as string,
      disable: false,
    },
    onAction: (): void => {
      this.updateCustomerEmail();
    },
  };
  public showPhoneUpdatePopup: IDialogOption = {
    width: 600,
    title: this.$parent.$t(
      'repairOrderDetails.updatePhoneDialog.title'
    ) as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t(
        'repairOrderDetails.updatePhoneDialog.btnUpdate'
      ) as string,
    },
    onAction: (): void => {
      this.updateCustomerPhone();
    },
  };

  public selectLanePopup: IDialogOption = {
    width: 400,
    title: this.$parent.$t(
      'repairOrderDetails.selectLaneDialog.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-money-bill',
      text: this.$parent.$t(
        'repairOrderDetails.selectLaneDialog.btnPay'
      ) as string,
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.makeVantivPayment(false);
    },
  };

  public reProcessPaymentDialog: IDialogOption = {
    width: 400,
    title: 'Process Payment',
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-money-bill',
      text: 'Approve',
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.reProcessPaymentDialog.loading = false;
      this.reProcessPaymentDialog.model = false;
      this.reProcessPaymentDialog.action.disable = false;
      this.makeVantivPayment(true);
    },
    onClose: (): void => {
      this.closeReProcessDialog();
    }
  };

  public closeReProcessDialog() {
    this.selectLanePopup.loading = false;
    this.selectLanePopup.model = false;
  }

  public selectCardPopup: IDialogOption = {
    width: 400,
    title: 'Select Card',
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-money-bill',
      text: 'Pay',
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.makeFileOnCardsPayment();
    },
  };

  public sendPaymentLinkPopup: IDialogOption = {
    width: 400,
    title: this.$parent.$t(
      'repairOrderDetails.sendPaymentLinkDialog.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-paper-plane',
      text: this.$parent.$t(
        'repairOrderDetails.sendPaymentLinkDialog.sendPaymentLink'
      ) as string,
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.sendPaymentLink();
    },
  };
  public manualPaymentPopup: IDialogOption = {
    width: 400,
    title: this.$parent.$t(
      'repairOrderDetails.manualPaymentDialog.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t(
        'repairOrderDetails.manualPaymentDialog.agree'
      ) as string,
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.payManually();
    },
  };
  public paymentAmountDialog: IDialogOption = {
    width: 450,
    title: this.$parent.$t(
      'repairOrderDetails.paymentAmountDialog.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-money-bill',
      text: this.$parent.$t(
        'repairOrderDetails.paymentAmountDialog.btnPay'
      ) as string,
    },
    onAction: (): void => {
      this.confirmPaymentDialog();
    },
  };

  public roDeductibleDialog: IDialogOption = {
    width: 450,
    title: this.$parent.$t(
      'repairOrderDetails.paymentAmountDialog.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-money-bill',
      text: this.$parent.$t(
        'repairOrderDetails.paymentAmountDialog.btnPay'
      ) as string,
    },
    onAction: (): void => {
      this.submitDeductiblePayment();
    },
    onClose: (): void => {
      this.closeDeductable();
    },
  };




  public closeDeductable() {
    this.isDeductiblePayment = false;
    this.payment.amountPaid = '';
    this.selectedPaymentType = '';
  }

  public submitDeductiblePayment() {
    try {
      this.amountToBePaid = this.payment.amountPaid;
      this.isDeductiblePayment = true;
      if (
        this.selectedPaymentType == '' ||
        this.selectedPaymentType == undefined
      ) {
        this.showAlert(false, 'Please select any payment method');
        return;
      }

      if (this.amountToBePaid == '' || this.amountToBePaid == undefined) {
        this.showAlert(false, 'Please add amount to be paid.');
        return;
      }

      switch (this.selectedPaymentType) {
        case 'rdVantiv':
          this.findLanes(true);
          break;
        case 'rdText':
          this.sendPaymentLinkPopup.model = true;
          break;
        case 'rdManual':
          if (this.roDetails.defaultPaymentProvider == 'Vantiv') {
            this.manualPaymentPopup.model = true;
          } else {
            this.paymentDialog = true;
            this.$root.$emit('validatePaymentProvider');
          }
      }
    } finally {
      //this.payment.amountPaid = '';
    }
  }

  public showCallPopup: IDialogOption = {
    width: 600,
    title: this.$parent.$t('repairOrderDetails.callDialog.title') as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-phone-volume',
      text: this.$parent.$t('repairOrderDetails.callDialog.btnCall') as string,
    },
    loading: false,
    onAction: (): void => {
      this.makeCall();
    },
  };

  public confirmResentPaymentLink: IDialogOption = {
    width: 400,
    title: this.$parent.$t(
      'repairOrderDetails.resentPaymentLink.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t(
        'repairOrderDetails.resentPaymentLink.btnConfirm'
      ) as string,
    },
    onAction: (): void => {
      this.confirmResentPaymentLinkPopUp();
    },
  };

  public loading: boolean = false;
  public paymentloading: boolean = false;
  public amountToBePaid: string = '0.00';
  public payment: any = {
    amountToBePaid: '',
    paymentMode: '',
    amountPaid: '',
    paymentType: '',
  };
  public signatureOptions: any = {
    'background-color': 'transparent',
    'decor-color': 'transparent',
  };
  public updateCustomerEmailModel: any = {
    customerEmail1: '',
    customerEmail2: '',
  };

  public query: any = {
    recordKey: '',
    customerKey: '',
    vin: '',
    sType: '',
  };
  public type: any;

  // Add Attachment Type fields
  public addAttachmentTypeModel: AddAttachmentModel = {};
  public attachmentDetails: AttachmentInfoViewModel[] = [];
  public videoLynkAttachments: any[] = [];

  public attachmentTypes: AttachmentType[] = [];
  public emailModel: RoEmailViewModel = {};
  public roDetails: RepairOrderViewModel = {};
  public paymentActions: any[] = [];
  public lanes: Lane[] = [];
  public getSelectedLaneList: any = [];
  public fileOnCardsList: any[] = [];
  public fileRef: any;
  public customerInfo: OpenRepairOrderViewModel = {};
  public videoActions: any[] = [];
  public fileUploderRef: string = "dealAttachmentsRef";

  public uploadBtnLoading: boolean = false;

  public roDeductibleHeaders: VHeaders[] = [
    {
      align: 'left',
      text: 'Account Number',
      sortable: false,
      value: `accountNumber`,
    },
    {
      align: 'left',
      text: 'Account Number',
      sortable: false,
      value: `documentNumber`,
    },
    {
      align: 'left',
      text: 'Amount',
      sortable: false,
      value: 'approvedAmount',
    },
    {
      align: 'left',
      text: 'GlStatus',
      value: 'glStatus',
      fieldType: 'template',
      sortable: false,
      template: (item) => {
        // tslint:disable-next-line:max-line-length
        return item.glStatus
          ? `<span style="color: green"> Success </span>`
          : `<span style="color: red" > Failed </span>`;
      },
    },
  ];

  public videolynkHeaders: VHeaders[] = [
    {
      align: 'left',
      text: 'DateTime',
      sortable: false,
      value: `createdDateTime`,
      fieldType: 'date',
    },
    {
      align: 'left',
      text: 'User',
      sortable: false,
      value: `userName`,
    },
    {
      align: 'left',
      text: 'View Time',
      sortable: false,
      value: 'requestInfo',
      filters: [
        (val, item) => {
          var accessLength = item.requestInfo.length;
          if (item && accessLength > 0) {
            return this.$moment(item.requestInfo[accessLength - 1].createdAt).format('lll');
          } else {
            return "N/A";
          }
        },
      ],
    },
    {
      align: 'left',
      text: 'Customer Feedback',
      sortable: false,
      value: 'userFeedback',
    },
    {
      align: 'left',
      text: 'Rating',
      sortable: false,
      value: 'rating',
    },
    {
      align: 'center',
      isNotDataProp: true,
      sortable: false,
      text: 'Action',
    }
  ];

  public textLogHeaders: VHeaders[] = [
    {
      align: 'left',
      text: this.$parent.$t('repairOrderDetails.roTextGrid.date') as string,
      value: `createdAt`,
      fieldType: 'date',
    },
    {
      align: 'left',
      text: this.$parent.$t('repairOrderDetails.roTextGrid.from') as string,
      value: `from`,
    },
    {
      align: 'left',
      text: this.$parent.$t('repairOrderDetails.roTextGrid.to') as string,
      value: 'to',
    },
    {
      align: 'left',
      text: this.$parent.$t('repairOrderDetails.roTextGrid.body') as string,
      value: 'message',
    },
  ];
  public paymentHeaders: VHeaders[] = [
    {
      align: 'left',
      text: this.$parent.$t(
        'repairOrderDetails.roPaymentGrid.status'
      ) as string,
      value: `status`,
      fieldType: 'html',
      filters: [
        (val) => {
          if (val && val !== 'N/A') {
            if (val === 'Approved' || val === 'COMPLETED') {
              return '<kbd class="green">' + val + '</kbd>';
            } else {
              return '<kbd class="red">' + val + '</kbd>';
            }
          }
        },
      ],
    },
    {
      align: 'left',
      text: this.$parent.$t('repairOrderDetails.roPaymentGrid.type') as string,
      value: `paymentType`,
      fieldType: 'html',
      filters: [
        (val) => {
          if (val && val !== 'N/A') {
            return '<kbd class="orange">' + val + '</kbd>';
          } else {
            return '';
          }
        },
      ],
    },
    {
      align: 'left',
      text: this.$parent.$t('repairOrderDetails.roPaymentGrid.name') as string,
      value: 'customerName',
    },
    {
      align: 'left',
      text: this.$parent.$t('repairOrderDetails.roPaymentGrid.date') as string,
      value: 'date',
      fieldType: 'date',
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'repairOrderDetails.roPaymentGrid.sentTo'
      ) as string,
      value: `paymentLinkSentTo`,
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'repairOrderDetails.roPaymentGrid.sentBy'
      ) as string,
      value: `performedByName`,
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'repairOrderDetails.roPaymentGrid.amount'
      ) as string,
      value: `approvedAmount`,
    },
  ];

  public updateCenposDialog(cenposDialogValue) {
    this.cenposDialog = cenposDialogValue;
  }

  public updateSendMessageDialog(sendMessageDialogValue) {
    this.sendMessageDialog = sendMessageDialogValue;
  }

  public updateSquareDialog(squareDialogValue) {
    this.squareDialog = squareDialogValue;
  }

  public customerPhoneNumber(): string {
    let pNumber = '';
    switch (this.customerInfo.callTo) {
      case 'home': {
        pNumber = this.customerInfo.customerPhoneNumber;
        break;
      }
      case 'cellphone': {
        pNumber = this.customerInfo.cellPhone;
        break;
      }
      case 'businessPhone': {
        pNumber = this.customerInfo.businessPhone;
        break;
      }
      case 'other': {
        pNumber = this.customerInfo.otherNumber;
        break;
      }
      default: {
        pNumber = this.customerInfo.customerPhoneNumber;
      }
    }
    return pNumber;
  }

  public async getAttachmentTypes(): Promise<void> {
    try {
      this.loading = true;
      const response = await attachmentTypeService.getAttachmentTypesListAsync();
      this.attachmentTypes = response.results;
      this.setAttachmentTypeItems('attachmentTypeId', this.attachmentTypes);
      this.showAddAttachmentPopup.model = true;
    } finally {
      this.loading = false;
    }
  }

  public validateAttachment(): Vue & { validate: () => boolean } {
    return this.$refs.attachmentForm as Vue & { validate: () => boolean };
  }

  public files: any = [];
  public attachmentFiles: FileViewModel[] = [];

  public fileDialog: IFileUploaderOption = {
    ref: this.fileUploderRef,
    inputFiles: this.files,
    multiple: true,
    drop: true,
  };

  public syncAttachmentFiles(inputFilesToSync: any[], outputFilesToSync: FileUploadDataViewModel[]) {
    this.files = inputFilesToSync;
    this.attachmentFiles = outputFilesToSync;
  }

  public fileUploadLoader(val: boolean) {
    this.uploadBtnLoading = val;
  }

  public confirmUpload(): void {
    if (this.attachmentFiles.length === 0) {
      this.showAlert(false, this.$t("Please select documents."));
      return;
    }
    this.uploadDialog.model = true;
  }

  public uploadDialog: IDialogOption = {
    width: 400,
    title: "Confirm",
    model: false,
    action: { color: "success", icon: "fas fa-check", text: "Agree" },
    loading: false,
    onAction: (): void => {
      this.saveAttachment();
    },
  };

  public async saveAttachment(): Promise<void> {
    // if (this.validateAttachment().validate()) {
    try {
      if (this.form.$valid) {
        this.showAddAttachmentPopup.loading = true;
        this.uploadBtnLoading = true;
        this.uploadDialog.loading = true;

        for (const fileToUpload of this.attachmentFiles) {
          try {
            // Get Blob upload url with SAS token
            var blobInfo = await repairOrderService.getClientUploadAttachmentInfo(
              this.addAttachmentTypeModel.roNumber,
              this.addAttachmentTypeModel.attachmentTypeId,
              this.addAttachmentTypeModel.customerName,
              fileToUpload.extension,
            );

            // Direct to blob upload
            var url = await blobStorageService.uploadBase64ToBlobStorage(
              fileToUpload.base64,
              fileToUpload.extension,
              blobInfo.blobUriWithToken
            );

            // Add attachment to the deal
            await repairOrderService.saveClientUploadRoAttachment(
              this.addAttachmentTypeModel.roNumber,
              this.addAttachmentTypeModel.attachmentTypeId,
              blobInfo.blobPath,
              this.addAttachmentTypeModel.vehicleIdNumber,
              this.addAttachmentTypeModel.comment,
              this.addAttachmentTypeModel.make,
              this.addAttachmentTypeModel.model,
              this.addAttachmentTypeModel.customerName,
              this.addAttachmentTypeModel.isPublic,
            );
            this.showAlert(true, this.$t('repairOrderDetails.alertAttachmentAdded'));
          } catch (err) {
            console.error(`Failed to upload file ${fileToUpload.fileName}:`, err);
            this.showAlert(false, `Failed to upload file ${fileToUpload.fileName}.`);
          }
        }
        // await repairOrderService.addAttachment(this.addAttachmentTypeModel);
        this.addAttachmentTypeModel.file = null;
        this.addAttachmentTypeModel.attachmentTypeId = 0;
        this.addAttachmentTypeModel.comment = '';
        if (this.fileRef) {
          this.fileRef.clear();
        }
        this.showAddAttachmentPopup.model = false;
        this.getAttachments();
      } else {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertPleaseFillRequiredFields')
        );
      }
    } finally {
      this.showAddAttachmentPopup.loading = false;
      this.$root.$emit('resetFileList', this.fileUploderRef);
      this.attachmentFiles = [];
      this.files = [];
      this.uploadDialog.loading = false;
      this.uploadDialog.model = false;
      this.uploadBtnLoading = false;
    }
    // }
  }

  public async getAttachments(): Promise<void> {
    if (!this.roDetails.closeDate) {
      const response = await repairOrderService.getAttachmentDetails(
        this.constants.roNumber,
        this.roDetails.vin
      );

      if (response.results) {
        this.attachmentDetails = response.results.
          filter(x => x.attachmentTypeName != 'Messaging Media' && !x.attachmentUri.includes('VideoClip'));

        this.videoLynkAttachments = response.results.
          filter(x => x.attachmentTypeName == 'Messaging Media' && x.attachmentUri.includes('VideoClip') && x.recordIdentifier == 'RO');

        this.attachmentDetails.forEach((att) => {
          att.selected = false;
        });

      }
      this.getCustomerDetail(this.roDetails.customerKey);

      this.flags.showAttachmentGrid = true;
      this.flags.showTextGrid = true;
      this.setVideoActions();
    }
  }

  public setFields(): void {
    this.formFields = addCustomUploaderAttachmentFields(this);
  }

  public setAttachmentTypeItems(fieldname: string, value: any[]) {
    const field = this.formFields.find((m) => {
      return m.key === fieldname;
    });
    if (field) {
      field.templateOptions.items = value;
    }
  }

  public async showAddAttachment() {
    try {
      this.snackbarText = 'Please wait while preparing attachment...';
      this.snackbar = true;
      if (this.attachmentTypes.length === 0) {
        await this.getAttachmentTypes();
      } else {
        this.showAddAttachmentPopup.model = true;
      }
      this.addAttachmentTypeModel = {
        customerName: this.roDetails.customerName,
        roNumber: this.roDetails.roNumber,
        vehicleIdNumber: this.roDetails.vin,
        make: this.roDetails.make,
        model: this.roDetails.model,
        attachmentTypeId: 0,
        comment: '',
        file: '',
        fileExtension: '',
      };
      this.setFields();
    }
    finally {
      this.snackbar = false;
    }
  }

  public updateTextPaging(paging: any): void {
    this.textPagination = paging;
  }

  public contactAt(): string {
    let ca = '';
    switch (this.roDetails.callTo) {
      case 'homePhone': {
        ca = this.roDetails.customerPhoneNumber;
        break;
      }
      case 'cellphone': {
        ca = this.roDetails.cellPhone;
        break;
      }
      case 'businessPhone': {
        ca = this.roDetails.businessPhone;
        break;
      }
      case 'email': {
        ca = this.roDetails.customerEmail;
        break;
      }
      default: {
        ca = '';
      }
    }
    return ca;
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }

  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.backToList();
    } else if (methodName === 'downloadRO') {
      this.downloadRO();
    } else if (methodName === 'addAttachment') {
      this.showAddAttachment();
    } else if (methodName === 'newMessage') {
      this.newMessage();
    } else if (methodName === 'newCall') {
      this.openCallPopup(this.roDetails);
    } else if (methodName === 'sendEmailRO') {
      this.sendEmailRO();
    } else if (methodName === 'sendSignatureEmailRO') {
      this.sendSignatureEmailRO();
    } else if (methodName === 'submitRO') {
      this.openCallPopup(this.submitRO);
    } else if (methodName === 'clearSignature') {
      this.clearSignature();
    } else if (methodName === 'payWithVantivTerminal') {
      if (
        Number(this.roDetails.displayDueAmount) <= 0 ||
        Number(this.roDetails.displayDueAmount) == NaN
      ) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertDueAmountMustGreaterThanZero')
        );
      } else {
        this.paymentAmountShowDialog('terminal');
      }
    } else if (methodName === 'payWithCardOnFile') {
      if (
        Number(this.roDetails.displayDueAmount) <= 0 ||
        Number(this.roDetails.displayDueAmount) == NaN
      ) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertDueAmountMustGreaterThanZero')
        );
      } else {
        this.paymentAmountShowDialog('cardOnFile');
      }
    } else if (methodName === 'addCardOnFile') {
      this.openCardForDetails();
    }
    else if (methodName === 'addCloverCardOnFile') {
      this.openCloverCardForDetails();
    }

    else if (methodName === 'sendPaymentLinkToCustomer') {
      if (
        Number(this.roDetails.displayDueAmount) <= 0 ||
        Number(this.roDetails.displayDueAmount) == NaN
      ) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertDueAmountMustGreaterThanZero')
        );
      } else {
        this.sendPaymentLinkPopup.model = true;
      }
    } else if (methodName === 'sendPaymentLinkToCustomer') {
      if (
        Number(this.roDetails.displayDueAmount) <= 0 ||
        Number(this.roDetails.displayDueAmount) === NaN
      ) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertDueAmountMustGreaterThanZero')
        );
      } else {
        this.sendPaymentLinkPopup.model = true;
      }
    } else if (methodName === 'payManuallyByCard') {
      if (
        Number(this.roDetails.displayDueAmount) <= 0 ||
        Number(this.roDetails.displayDueAmount) === NaN
      ) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertDueAmountMustGreaterThanZero')
        );
      } else {
        this.paymentAmountShowDialog('manual');
      }
    } else if (methodName == 'creditCardPrice') {
      this.creditCardPrice();
    } else if (methodName == 'cashPrice') {
      this.cashPrice();
    } else if (methodName == 'addCreditCardFees') {
      this.openCreditCardFeeDialog();
    }

    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public updateToolBar(): void {
    const buttons: any = [];
    if (this.flags.isClosed && this.flags.showDetails) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t(
          'repairOrderDetails.toolbar.btnBackToListTitle'
        ) as string,
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t(
          'repairOrderDetails.toolbar.btnBackToList'
        ) as string,
        click: 'backToList',
        icon: 'fas fa-arrow-left',
      });
    } else if (!this.flags.isClosed && this.flags.showDetails) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t(
          'repairOrderDetails.toolbar.btnBackToListTitle'
        ) as string,
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t(
          'repairOrderDetails.toolbar.btnBackToList'
        ) as string,
        click: 'backToList',
        icon: 'fas fa-arrow-left',
      });
      buttons.push({
        id: '1',
        type: 'button',
        title: 'Attachment Ops',
        class: 'btn',
        label: 'Attachment Ops',

        childButton: [
          {
            id: '2',
            type: 'button',
            title: this.$parent.$t(
              'repairOrderDetails.toolbar.downloadRO'
            ) as string,
            disabled: false,
            visible: true,
            class: 'btn',
            label: this.$parent.$t(
              'repairOrderDetails.toolbar.downloadRO'
            ) as string,
            click: 'downloadRO',
            icon: 'fas fa-download',
          },
          {
            id: '3',
            type: 'button',
            title: this.$parent.$t(
              'repairOrderDetails.toolbar.addAttachment'
            ) as string,
            disabled: false,
            visible: true,
            class: 'btn',
            label: this.$parent.$t(
              'repairOrderDetails.toolbar.addAttachment'
            ) as string,
            click: 'addAttachment',
            icon: 'fas fa-plus',
          },
          {
            id: '4',
            type: 'button',
            title: this.$parent.$t(
              'repairOrderDetails.toolbar.email'
            ) as string,
            disabled: false,
            visible: this.roDetails.isAdvisorRole,
            class: 'btn',
            label: this.$parent.$t(
              'repairOrderDetails.toolbar.email'
            ) as string,
            click: 'sendEmailRO',
            icon: 'fas fa-envelope',
          },
        ],
      });
      if (
        this.roDetails.isMessagingEnabled &&
        this.roDetails.isAdvisorRole &&
        this.roDetails.customerPhoneNumber &&
        this.roDetails.customerPhoneNumber !== '0' &&
        this.isFeatureToAccess('MESSAGING')
      ) {
        buttons.push({
          label: 'Contact Customer',
          type: 'button',
          id: '5',
          childButton: [
            {
              id: '6',
              type: 'button',
              title: this.$parent.$t(
                'repairOrderDetails.toolbar.newMessage'
              ) as string,
              disabled: false,
              visible: true,
              class: 'btn',
              label: this.$parent.$t(
                'repairOrderDetails.toolbar.newMessage'
              ) as string,
              click: 'newMessage',
              icon: 'fas fa-comment',
            },
            {
              id: '7',
              type: 'button',
              title: this.$parent.$t(
                'repairOrderDetails.toolbar.newCall'
              ) as string,
              disabled: false,
              visible: true,
              class: 'btn',
              label: this.$parent.$t(
                'repairOrderDetails.toolbar.newCall'
              ) as string,
              click: 'newCall',
              icon: 'fas fa-phone',
            },
          ],
        });
      }

      if (this.roDetails.status == 'Pre-Invoice') {
        buttons.push({
          id: '8',
          type: 'button',
          title: 'Take Kiosk Signature',
          disabled: this.roDetails.isSubmitted,
          visible: true,
          class: 'btn',
          label: 'Kiosk Sign',
          click: 'sendSignatureEmailRO',
          icon: 'fas fa-signature',
        });
      }

      if (
        this.roDetails &&
        !this.flags.paymentApproved &&
        (this.roDetails.status === 'Pre-Invoice' || this.roDetails.isCreditCardFeeEnabled)
      ) {
        buttons.push({
          id: '9',
          type: 'button',
          title: 'Pay Now',
          class: 'btn',
          label: 'Pay Now',
          childButton: [
            {
              id: '10',
              type: 'button',
              title:
                this.roDetails.defaultPaymentProvider == 'Vantiv'
                  ? (this.$parent.$t(
                    'repairOrderDetails.toolbar.payWithVantivTerminal'
                  ) as string)
                  : this.roDetails.defaultPaymentProvider == 'Square' ? (this.$parent.$t(
                    'repairOrderDetails.toolbar.payWithSquareTerminal'
                  ) as string) : "Pay With Payroc Terminal",

              disabled: false,
              visible:
                ((this.roDetails.defaultPaymentProvider == 'Vantiv' ||
                  this.roDetails.defaultPaymentProvider == 'Square' || this.roDetails.defaultPaymentProvider == 'Payroc') &&
                  this.roDetails.isTerminalPaymentEnabled),
              class: 'btn primary',
              label:
                this.roDetails.defaultPaymentProvider == 'Vantiv'
                  ? (this.$parent.$t(
                    'repairOrderDetails.toolbar.payWithVantivTerminal'
                  ) as string)
                  : this.roDetails.defaultPaymentProvider == 'Square' ? (this.$parent.$t(
                    'repairOrderDetails.toolbar.payWithSquareTerminal'
                  ) as string) : "Pay With Payroc Terminal" + this.roDetails.displayDueAmount,
              click: 'payWithVantivTerminal',
              icon: 'fas fa-money-bill',
            },
            {
              id: '11',
              type: 'button',
              title: this.$parent.$t(
                'repairOrderDetails.toolbar.sendPaymentLInkToCustomer'
              ) as string,
              disabled: false,
              visible: true,
              class: 'btn primary',
              label: this.$parent.$t(
                'repairOrderDetails.toolbar.sendPaymentLinkToCustomer'
              ) as string,
              click: 'sendPaymentLinkToCustomer',
              icon: 'fas fa-paper-plane',
            },
            {
              id: '12',
              type: 'button',
              title: this.$parent.$t(
                'repairOrderDetails.toolbar.sPayManuallyByCard'
              ) as string,
              disabled: false,
              visible: true,
              class: 'btn primary',
              label: this.$parent.$t(
                'repairOrderDetails.toolbar.sPayManuallyByCard'
              ) as string,
              click: 'payManuallyByCard',
              icon: 'fas fa-credit-card',
            },
            {
              id: '13',
              type: 'button',
              title: 'PAY WITH CARD ON FILE',
              disabled: false,
              visible:
                this.fileOnCardsList &&
                this.fileOnCardsList.length > 0,
              class: 'btn primary',
              label: 'PAY WITH CARD ON FILE',
              click: 'payWithCardOnFile',
              icon: 'fas fa-credit-card',
            },
            {
              id: '13',
              type: 'button',
              title: 'Add Credit Card Fees',
              disabled: false,
              visible: this.roDetails.isCreditCardFeeEnabled && !this.roDetails.isCreditFeesAdded,
              class: 'btn primary',
              label: 'Add Credit Card Fees ' + this.creditCardTotalFeeWithouTax,
              click: 'addCreditCardFees',
              icon: 'fas fa-credit-card',
            },
          ],
        });
        if (this.roDetails.customerKey) {
          buttons.push({
            id: '15',
            type: 'button',
            title: 'Add Card on File',
            disabled: false,
            visible: true,
            class: 'btn primary',
            label: 'Add Card on File',
            click: 'addCardOnFile',
            icon: 'fas fa-plus-circle',
          });
        }
      }
    }
    if (this.roDetails.isCreditCardFeeEnabled) {
      buttons.push({
        id: '16',
        type: 'button',
        title: 'Credit Card Price',
        disabled: false,
        visible: true,
        class: (this.roDetails.isCreditFeesAdded ? 'btn success' : 'btn'),
        label: 'Credit Card Price ' + this.displayTotalDueWithFee.toString(),
        click: 'creditCardPrice',
        icon: 'fa-duotone fa-credit-card',
      });
      buttons.push({
        id: '17',
        type: 'button',
        title: 'Cash Price',
        disabled: false,
        visible: true,
        class: 'btn',
        label: 'Cash Price ' + this.roDetails.displayDueAmount.toString(),
        click: 'cashPrice',
        icon: 'fa-duotone fa-money-bill',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted(): void {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'openRo');
    // Toolbar
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.$watch(
      "roDetails",
      (newVal) => {
        this.paymentOptions.customerKey = newVal.customerKey;
        this.paymentOptions.vin = newVal.vin;
        this.paymentOptions.address = newVal.customerStreetAddress1 + ' ' + newVal.customerStreetAddress2;
        this.paymentOptions.city = newVal.customerCity;
        this.paymentOptions.state = newVal.customerState;
        this.paymentOptions.zipcode = newVal.customerZip;
        this.paymentOptions.customerEmail = newVal.customerEmail1;
        this.paymentOptions.merchantEmail = newVal.merchantEmail;
        this.paymentOptions.recordKey = newVal.roNumber;
      },
      {
        deep: true, // Enables deep watching
      }
    );

    this.$watch('amountToBePaid', (newVal) => {
      this.paymentOptions.amount = Number(newVal);
    });

    this.$watch('isAmountOverride', (newVal) => {
      this.paymentOptions.isAmountOverride = newVal;
    });

    this.$watch('isSendPaymentReceipt', (newVal) => {
      this.paymentOptions.isSendPaymentReceipt = newVal;
    });
    this.$watch('bypassReason', (newVal) => {
      this.paymentOptions.bypassReason = newVal;
    });
    this.$watch('isOverrideCCFeeApplied', (newVal) => {
      this.paymentOptions.isOverrideCCFeeApplied = newVal;
    }); this.$watch('isDeductiblePayment', (newVal) => {
      this.paymentOptions.isDeductiblePayment = newVal;
    });

    this.currentUrl = window.location.href;
    this.constants.roNumber = this.$route.params.roNumber;
    if (this.constants.roNumber) {
      this.getOrderDetail();
    }

    this.setFields();
    this.findLanes();

    var role = [RoleType.BypassCreditCardFee.toString()];
    var isRoleAllowed = this.userSession.roles.filter(x => role.includes(x));
    this.isBypassCreditCardFeeRole = isRoleAllowed.includes(role[0]);


  }

  public openCardForDetails() {
    this.showAddCardDetails = true;
  }

  public openCloverCardForDetails() {
    this.showCloverAddCardDetails = true;
  }

  public closeCard() {
    this.showAddCardDetails = false;
    this.showCloverAddCardDetails = false;
  }

  public updated(): void {
    const vm = this;
    if (this.$refs.signature) {
      document.getElementById(this.$refs.signature['uid']).onmousedown = (
        evt
      ) => {
        vm.flags.touchStarted = true;
      };
    }
  }

  public async getOrderDetail(): Promise<void> {
    try {
      this.roDetailLoading = true;
      this.loading = true;
      this.paymentloading = true;
      const response = await repairOrderService.getRepairOrderDetails(
        this.constants.roNumber
      );
      this.roDetails = response;
      this.fileOnCardsList = response.cards;
      this.addCardCustomerKey = response.customerKey;
      if (this.roDetails.finalCloseDate) {
        this.flags.isClosed = true;
      }
      this.flags.showDetails = true;
      if (
        this.roDetails.paymentDetail &&
        this.roDetails.paymentDetail.paymentResponses
      ) {
        this.roDetails.paymentDetail.paymentResponses.forEach((resp) => {
          resp.customerName = this.roDetails.customerName;
          resp.roNumber = this.roDetails.roNumber;
        });
        this.pagedPayments = this.roDetails.paymentDetail.paymentResponses;
        this.roDeductablePayments = this.roDetails.paymentDetail.paymentResponses.filter(
          (x) => x.isDeductiblePayment
        );
        this.paymentPagination.totalItems = this.pagedPayments.length;
        this.roDeductablePagination.totalItems = this.roDeductablePayments.length;
        this.pagedTextLog = this.roDetails.messages || [];
        this.textPagination.totalItems = this.pagedTextLog.length;

        if (
          this.roDetails.paymentDetail &&
          this.roDetails.paymentDetail.paymentResponses &&
          this.roDetails.paymentDetail.paymentResponses.length > 0
        ) {
          this.flags.showPaymentGrid = true;

          const approvedPayment = this.roDetails.paymentDetail.paymentResponses.find(
            (pay) => {
              return pay.status === 'Approved';
            }
          );
          if (this.roDetails.paymentDetail.status === 'Approved') {
            this.flags.paymentApproved = true;
          }
        }
      }
      this.calculateCreditCardFee();
      this.updateToolBar();
      this.getAttachments();
      this.customerUpdateViewModel.businessPhone = this.roDetails.businessPhone.replace(
        /[.*+?^${}()|[\]\\]/g,
        ''
      );
      this.customerUpdateViewModel.phoneNumber = this.roDetails.homePhone.replace(
        /[.*+?^${}()|[\]\\]/g,
        ''
      );
      this.customerUpdateViewModel.cellPhone = this.roDetails.cellPhone.replace(
        /[.*+?^${}()|[\]\\]/g,
        ''
      );
    } finally {
      this.paymentloading = false;
      this.loading = false;
      this.roDetailLoading = false;
      this.updateToolBar();
    }
  }

  public backToList(): void {
    if (history.state && history.length > 1) {
      this.$router.back();
    } else {
      if (this.$route.query['sType'] && this.$route.query['sType'] === 'n') {
        this.$router.push({
          name: 'app.repairorders',
        });
      } else {
        this.$router.push({
          name: 'app.repairorders.open',
        });
      }
    }
  }
  public cashPrice(): void {
  }

  public creditCardPrice(): void {
  }

  public updatePaging(paging: any) {
    this.paymentPagination = paging;
    this.paymentPagination.sortBy = paging.sortBy;
    this.paymentPagination.descending = paging.descending;
  }

  public updateFlag(flag, value): void {
    this.flags[flag] = value;
  }
  public initPayment(): void {
    if (
      Number(this.roDetails.displayDueAmount) <= 0 ||
      Number(this.roDetails.displayDueAmount) == NaN
    ) {
      this.showAlert(
        false,
        this.$t('repairOrderDetails.alertDueAmountMustGreaterThanZero')
      );
    } else {
      this.paymentAmountShowDialog('terminal');
    }
  }

  public newMessage(): void {
    this.query = {
      recordKey: this.roDetails.roNumber,
      customerKey: this.roDetails.customerKey,
      vin: this.roDetails.vin,
      sType: this.$route.query['sType'],
    };
    this.type = MetadataType[MetadataType.RO];
    this.sendMessageDialog = true;
  }

  public async downloadRO(): Promise<void> {
    try {
      this.loading = true;
      this.$emit('update:progress', this.loading);
      this.snackbarText = 'Please wait while we download the repair order…';
      this.snackbar = true;
      let sign = null;
      if (this.$refs.signature) {
        sign = this.$refs.signature['save']('image/jpeg');
      }

      try {
        await repairOrderService.saveRoPdf(this.roDetails, sign);
      } catch (err) {
        this.showNotification(NotificationType.Warning, "Repair order not found. Unable to download the file.");
      }
    } finally {
      this.loading = false;
      this.$emit('update:progress', this.loading);
      this.snackbar = false;
    }
  }

  public async downloadReceipt(payment): Promise<void> {
    try {
      this.loading = true;

      if (payment.provider == "Square") {
        const response = await paymentReportService.downloadReceipt(
          this.roDetails.paymentDetail.transactionHeaderId,
          payment.id,
          payment.paymentType
        );

        if (response?.fileDownloadName) {
          window.open(response.fileDownloadName, '_blank');
        } else {
          this.showNotification(NotificationType.Warning, "Receipt is not available for this transaction.");
        }
      }
      else {
        const response = await paymentService.downloadReceipt(
          this.roDetails.paymentDetail.transactionHeaderId,
          payment.id
        );
        const bytes = _file.base64ToArrayBuffer(response.fileContent);
        _file.downloadBytes(bytes, '', response.fileDownloadName);
      }
    } finally {
      this.loading = false;
    }
  }

  public clearSignature(): void {
    this.flags.touchStarted = false;
    this.$refs.signature['clear']();
  }

  public parseVendorResponse(vendorString): any {
    if (vendorString != '') {
      return JSON.parse(vendorString || '{}');
    }
  }

  public submitRO(): void {
    this.roDetails.buttonType = 'submit';
    this.roDetails.isSubmitted = true;
    this.flags.showSendEmailPopup = true;
  }

  public payWithVantivTerminal(): void {
    if (
      Number(this.amountToBePaid) === 0 ||
      isNaN(Number(this.amountToBePaid))
    ) {
      this.showAlert(false, this.$t('repairOrderDetails.alertDueAmountIsZero'));
      return;
    }

    if (Number(this.amountToBePaid) < 0) {
      this.showAlert(false, 'Amount Should be greater than 0');
      return;
    }
    this.findLanes(true);
  }

  public payWithCardOnFile(): void {
    if (
      Number(this.amountToBePaid) === 0 ||
      isNaN(Number(this.amountToBePaid))
    ) {
      this.showAlert(false, this.$t('repairOrderDetails.alertDueAmountIsZero'));
      return;
    }

    if (Number(this.amountToBePaid) < 0) {
      this.showAlert(false, 'Amount Should be greater than 0');
      return;
    }
    this.findCards();
  }

  public async makeFileOnCardsPayment(): Promise<void> {
    const amount = this.roDetails.displayDueAmount;
    try {
      this.selectCardPopup.action.disable = true;
      this.selectCardPopup.loading = true;
      if (
        Number(this.amountToBePaid) === 0 ||
        isNaN(Number(this.amountToBePaid))
      ) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertDueAmountIsZero')
        );
        return;
      }

      if (Number(this.amountToBePaid) < 0) {
        this.showAlert(false, 'Amount Should be greater than 0');
        return;
      }

      if (!this.constants.cardId) {
        this.showAlert(false, 'Please select Card');
        this.selectCardPopup.action.disable = false;
        this.selectCardPopup.loading = false;
        return;
      }

      this.roDetails.displayDueAmount = this.amountToBePaid;
      this.roDetails.recordIdentifier = 'RO';
      const response = await repairOrderService.makeCardOnFilePayment(
        this.roDetails,
        this.constants.cardId,
        this.isOverrideCCFeeApplied,
        this.bypassReason
      );

      this.roDetails.displayDueAmount = amount;

      if (response.isSuccess) {
        this.showAlert(true, response.responseMessage);
        if (response.recieptUrl != null) {
          window.open(response.recieptUrl, '_blank');
        }
      } else {
        this.showAlert(false, 'fail to make payment');
      }
    } catch {
      this.roDetails.displayDueAmount = amount;
    } finally {
      this.selectCardPopup.action.disable = false;
      this.selectCardPopup.model = false;
      this.selectCardPopup.loading = false;
      this.bypassReason = "";
    }
  }

  // VANTIV TERMINAL PAYMENT
  public async makeVantivPayment(isProcess: boolean): Promise<void> {
    const amount = this.roDetails.displayDueAmount;
    try {

      if (
        Number(this.amountToBePaid) === 0 ||
        isNaN(Number(this.amountToBePaid))
      ) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertDueAmountIsZero')
        );
        return;
      }

      if (Number(this.amountToBePaid) < 0) {
        this.showAlert(false, 'Amount Should be greater than 0');
        return;
      }

//comment this for now 
  //     const validateDueAmountResponse = await repairOrderService.validateDueAmountRequest(
  //   this.roDetails.storeId,
  //   this.constants.roNumber,
  //   this.roDetails.defaultPaymentProvider
  // );
  //   // If no payment is due, isPaymentDue is false and message contains the reason.
  //   if(!validateDueAmountResponse.isPaymentDue && validateDueAmountResponse.message){
  //       this.showNotification(NotificationType.Warning,validateDueAmountResponse.message);
  //           return;
  //   }

      if (!this.lane) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertPleaseSelectLane')
        );
        return;
      }

      this.selectLanePopup.action.disable = true;
      this.selectLanePopup.loading = true;

      this.roDetails.displayDueAmount = this.amountToBePaid;
      this.roDetails.isSendPaymentReceipt = this.isSendPaymentReceipt;
      const response = await repairOrderService.makeVantivPayment(
        this.roDetails,
        this.lane,
        this.isDeductiblePayment,
        isProcess,
        this.isOverrideCCFeeApplied,
        this.bypassReason
      );

      if (response.isPaymentAlreadyInitiated) {
        this.reProcessPaymentDialog.model = true;
        this.reProcessPaymentDialog.loading = true;
        this.reProcessPaymentDialog.action.disable = false;
      } else {
        this.reProcessPaymentDialog.model = false;
        this.reProcessPaymentDialog.loading = false;

        var isInProcess = false;
        var isFailed = false;
        var isApproved = false;
        //For Payroc payments, the payment status is updated via a web job, so there's no need to check the payment status repeatedly
        if (this.roDetails.defaultPaymentProvider != 'Payroc') {
          for (var i = 0; i <= 3; i++) {
            await new Promise((resolve) => setTimeout(resolve, 15000)); // 3 sec
            const paymentResponse = await paymentService.getPaymentDetailStatus(
              response.transactionHeaderId,
              response.transactionDetailId
            );

            if (paymentResponse.status == 'Approved') {
              isApproved = true;
              break;
            }
          }
        } else {
          const paymentResponse = await paymentService.getPaymentDetailStatus(
            response.transactionHeaderId,
            response.transactionDetailId
          );
          if (paymentResponse.status == "InProcess") {
            isInProcess = true;
          }
          else if (paymentResponse.status == "Failed") {
            isFailed = true;
          }
        }
        this.isShowWarning = true;
        if (isFailed) {
          this.selectLanePopup.model = false;
          this.showAlert(false, "Payment Failed. Please Try Again");
        }
        else if (isInProcess) {
          this.warningMessage = "Payment Created Successfully, Please check the final status in Payment report.";
        }
        else if (isApproved) {
          this.warningMessage = "Payment is Approved Successfully.";
          this.showAlert(true, "Payment is Approved Successfully.");
        }
        else {
          this.warningMessage = "Approving Payment callback taking a longer time, Please check the payment final status in Payment report.";
        }
        this.selectLanePopup.action.disable = true;
        this.roDetails.displayDueAmount = amount;
        this.isShowWarning = true;
        this.selectLanePopup.loading = false;
      }
    } catch {
      this.roDetails.displayDueAmount = amount;
      this.selectLanePopup.loading = false;
      this.roDeductibleDialog.model = false;
    } finally {
      this.roDeductibleDialog.action.disable = false;
      this.payment.amountPaid = '';
      this.bypassReason = "";
    }
  }

  // SEND PAYMENT LINK
  public async sendPaymentLink(forceSent: boolean = false): Promise<void> {
    if (this.validateForm()) {
      this.roDetails.contactAt = this.contactAt();
      if (!this.roDetails.contactAt) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertPleaseSelectAtLeastOneContact')
        );
        return;
      }

      if (!this.isDeductiblePayment) {
        if (
          Number(this.roDetails.displayDueAmount) === 0 ||
          isNaN(Number(this.roDetails.displayDueAmount))
        ) {
          this.showAlert(
            false,
            this.$t('repairOrderDetails.alertDueAmountIsZero')
          );
          return;
        }

        let amount = '0.00';

        if (this.payment.paymentMode === 'full') {
          amount = this.roDetails.displayDueAmount;
        } else if (this.payment.paymentMode === 'partial') {
          amount = this.payment.amountPaid;
        } else {
          this.showAlert(
            false,
            this.$t('repairOrderDetails.alertPleaseSelectOnePaymentType')
          );
          return;
        }

        if (!amount && Number(amount) <= 0) {
          this.showAlert(
            false,
            this.$t(
              'repairOrderDetails.alertAmountShouldGreaterThanZeroAndValid'
            )
          );
          return;
        }

        if (Number(amount) < 0) {
          this.showAlert(false, 'Amount Should be greater than 0');
          return;
        }

        if (Number(amount) > Number(this.roDetails.displayDueAmount)) {
          this.showAlert(
            false,
            this.$t('repairOrderDetails.alertAmountShouldLessThanTotalDue')
          );
          return;
        }

        this.amountToBePaid = amount;
      } else {
        this.amountToBePaid = this.payment.amountPaid;
      }

      var displayDueAmount = this.roDetails.displayDueAmount;
      try {
        this.roDetails.displayDueAmount = this.amountToBePaid;
        this.sendPaymentLinkPopup.action.disable = true;
        this.sendPaymentLinkPopup.loading = true;
        this.roDetails.isSendPaymentReceipt = this.isSendPaymentReceipt;
        const res = await repairOrderService.sendPaymentLink(
          this.roDetails,
          forceSent,
          this.isDeductiblePayment,
          this.isOverrideCCFeeApplied,
          this.bypassReason
        );
        if (res.linkAlreadySent) {
          this.sendPaymentLinkPopup.model = false;
          this.paymentLinkText = res.message;
          this.confirmResentPaymentLink.model = true;
        } else {
          this.showAlert(true, res.message);
          this.payment.amountPaid = '';
        }
      } finally {
        this.roDetails.displayDueAmount = displayDueAmount;
        this.sendPaymentLinkPopup.action.disable = false;
        this.sendPaymentLinkPopup.loading = false;
        this.sendPaymentLinkPopup.model = false;
        this.roDeductibleDialog.model = false;
        this.roDeductibleDialog.action.disable = false;
      }
    }
  }

  public async confirmResentPaymentLinkPopUp(): Promise<void> {
    this.sendPaymentLink(true);
    this.confirmResentPaymentLink.model = false;
  }

  // PAY MANUALLY
  public async payManually(): Promise<void> {
    if (
      Number(this.amountToBePaid) === 0 ||
      isNaN(Number(this.amountToBePaid))
    ) {
      this.showAlert(false, this.$t('repairOrderDetails.alertDueAmountIsZero'));
      return;
    }

    if (Number(this.amountToBePaid) < 0) {
      this.showAlert(false, 'Amount Should be greater than 0');
      return;
    }
    // copy amountToBePaid to displayDue
    const amount = this.roDetails.displayDueAmount;
    try {
      this.manualPaymentPopup.action.disable = true;
      this.manualPaymentPopup.loading = true;
      this.roDetails.displayDueAmount = this.amountToBePaid;
      this.roDetails.isSendPaymentReceipt = this.isSendPaymentReceipt;
      const response = await repairOrderService.payManually(
        this.roDetails,
        this.isDeductiblePayment
      );
      location.href = response.redirectUri;
    } catch (e) {
      this.roDetails.displayDueAmount = amount;
    } finally {
      this.manualPaymentPopup.action.disable = false;
      this.manualPaymentPopup.loading = false;
      this.manualPaymentPopup.model = false;
    }
  }

  // GET LANES
  public async getLanes(): Promise<void> {
    try {
      this.isLaneLoading = true;
      const response = await laneService.getLanesAsync();
      this.getSelectedLaneList = response.results;
      this.lane = "";
    } finally {
      this.isLaneLoading = false;
    }
  }

  public async sendEmailRO(): Promise<void> {
    this.snackbarText = 'Please wait while we retrieve the email record…';
    this.snackbar = true;
    await this.$nextTick();
    this.roDetails.buttonType = 'email';
    this.flags.showSendEmailPopup = true;
    this.snackbar = false;
  }
  public sendSignatureEmailRO(): void {
    this.roDetails.buttonType = 'signatureEmail';
    this.flags.showSendSignatureEmailPopup = true;
  }

  public paymentAmountShowDialog(paymentType: string) {
    this.payment.paymentType = '';
    this.payment.amountPaid = '';
    switch (paymentType) {
      case PaymentTypeDialog.terminal:
        this.payment.paymentType = PaymentTypeDialog.terminal;
        break;
      case PaymentTypeDialog.manual:
        this.payment.paymentType = PaymentTypeDialog.manual;
        break;
      case PaymentTypeDialog.cardOnFile:
        this.payment.paymentType = PaymentTypeDialog.cardOnFile;
        break;
      default:
        this.payment.paymentType = '';
        break;
    }
    this.paymentAmountDialog.model = true;
  }

  public confirmPaymentDialog() {
    this.isDeductiblePayment = false;
    if (this.validateForm()) {

      let amount = '0.00';
      // get amountToBePaid
      if (this.payment.paymentMode === 'full') {
        amount = this.roDetails.displayDueAmount;
      } else if (this.payment.paymentMode === 'partial') {
        amount = this.payment.amountPaid;
      } else {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertPleaseSelectOnePaymentType')
        );
        return;
      }

      if (Number(amount) < 0) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertAmountShouldBeGreater')
        );
        return;
      }

      if (!amount && Number(amount) <= 0) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertAmountShouldGreaterThanZeroAndValid')
        );
        return;
      }

      if (Number(amount) > Number(this.roDetails.displayDueAmount)) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertAmountShouldLessThanTotalDue')
        );
        return;
      }

      if (!this.isOverrideCCFeeApplied && this.bypassReason == "") {

        this.showAlert(
          false,
          'The Bypass Reason field is required'
        );
        return;

      }


      this.paymentAmountDialog.model = false;
      this.amountToBePaid = amount;
      this.roDetails.isSendPaymentReceipt = this.isSendPaymentReceipt;
      // show modal popup
      switch (this.payment.paymentType) {
        case PaymentTypeDialog.terminal:
          this.payWithVantivTerminal();
          break;
        case PaymentTypeDialog.cardOnFile:
          this.payWithCardOnFile();
          break;
        case PaymentTypeDialog.manual:
          if (
            Number(this.amountToBePaid) === 0 ||
            isNaN(Number(this.amountToBePaid))
          ) {
            this.showAlert(
              false,
              this.$t('repairOrderDetails.alertDueAmountIsZero')
            );
            return;
          }

          if (this.roDetails.defaultPaymentProvider == 'Vantiv') {
            this.manualPaymentPopup.model = true;
          } else {
            this.paymentDialog = true;
            this.$root.$emit('validatePaymentProvider');
          }
          break;
        default:
          break;
      }
    }
    this.payment.paymentMode = '';
  }

  public validateWebPayment(): string {
    let message = '';
    if (
      this.roDetails.customerCity == undefined ||
      this.roDetails.customerCity == ''
    ) {
      message += ' City';
    }
    if (
      this.roDetails.customerKey == undefined ||
      this.roDetails.customerKey == ''
    ) {
      message += ' CustomerKey';
    }

    if (
      this.roDetails.customerState == undefined ||
      this.roDetails.customerState == ''
    ) {
      message += ' State';
    }
    if (
      this.roDetails.customerStreetAddress1 == undefined &&
      this.roDetails.customerStreetAddress1 == ''
    ) {
      message += ' Address';
    }

    return message;
  }

  public async findCards(): Promise<void> {
    this.selectCardPopup.model = true;
  }

  public async findLanes(openLanePopUp: boolean = false): Promise<void> {
    this.warningMessage = '';
    this.isShowWarning = false;
    this.selectLanePopup.action.disable = false;
    if (openLanePopUp) {
      this.selectLanePopup.model = true;
      if (this.lanes.length === 0) {
        await this.getLanes();
      }
    }
  }

  public fixDecimalValue(value) {
    if (this.payment.amountPaid) {
      const amount = Number(this.payment.amountPaid);
      const val = amount.toFixed(2);
      this.payment.amountPaid = val;
    } else {
      this.payment.amountPaid = undefined;
    }
  }

  public resetBypassReason(value) {
    if (value) {
      this.bypassReason = '';
    }
  }

  public async openCallPopup(model): Promise<void> {
    try {
      this.loading = true;
      this.$emit('update:progress', this.loading);
      const response = await customerService.getCustomerInfoAsync(
        model.customerKey
      );
      const keys = Object.keys(response);
      keys.forEach((key) => {
        model[key] = response[key];
      });
      this.customerInfo = model;
      this.customerInfo.callType = this.roDetails.callTypes[0].id;
      this.showCallPopup.model = true;
      this.customerInfo.callTo = 'home';
      this.customerInfo.otherNumber = '';
    } finally {
      this.loading = false;
      this.$emit('update:progress', this.loading);
    }
  }

  public async makeCall(): Promise<void> {
    if (this.validateForm()) {
      const voiceCallModel: VoiceCallModel = {
        callType: this.customerInfo.callType,
        customerKey: this.customerInfo.customerKey,
        customerName: this.customerInfo.customerName,
        recordIdentifier: MetadataType[MetadataType.RO],
        recordKey: this.roDetails.roNumber,
        recordKeyIdentifier:
          MetadataKeyIdentifier[MetadataKeyIdentifier.RepairOrderNumber],
        toNumber: this.customerPhoneNumber(),
        vin: this.roDetails.vin,
      };
      if (!voiceCallModel.toNumber || voiceCallModel.toNumber === '0') {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertCustomerPhoneNumberCannotEmpty')
        );
        return;
      }
      try {
        this.showCallPopup.loading = true;
        const response = await voiceCallService.makeOutboundCallAsync(
          voiceCallModel
        );
        this.showAlert(true, response.message);
      } finally {
        this.showCallPopup.loading = false;
        this.flags.showCallPopup = false;
      }
    }
  }

  public async updateCustomerEmail(): Promise<void> {
    this.showEmailUpdatePopup.loading = true;
    if ((!this.roDetails.customerEmail1 || this.roDetails.customerEmail1 == '')
      && (!this.roDetails.customerEmail2 || this.roDetails.customerEmail2 == '')) {
      this.showAlert(
        false,
        "At least 1 email is required"
      );
      this.showEmailUpdatePopup.loading = false;
      return;
    }
    if (!this.roDetails.customerLastName || this.roDetails.customerLastName == '') {
      this.showAlert(
        false,
        "Customer details not found."
      );
      this.showEmailUpdatePopup.loading = false;
      return;
    }

    if (!(await this.validateFormByScope('customerMail'))) {
      this.showEmailUpdatePopup.loading = false;
      return;
    }
    const model = {
      UpdateType: 'email',
      Email1: this.roDetails.customerEmail1,
      Email2: this.roDetails.customerEmail2,
      CustomerNumber: this.roDetails.customerKey,
      FirstName: this.roDetails.customerFirstName,
      LastName: this.roDetails.customerLastName,
      TypeCode: this.roDetails.customerTypeCode,
    };

    try {
      await customerService.updateAsync(model);
      this.showAlert(
        true,
        this.$t('repairOrderDetails.alertCustomerEmailUpdatedSuccessfully')
      );
      this.roDetails.customerEmail = model.Email1 || model.Email2;
    } finally {
      this.showEmailUpdatePopup.loading = false;
      this.showEmailUpdatePopup.model = false;
    }
  }
  public async updateCustomerPhone(): Promise<void> {
    this.showPhoneUpdatePopup.loading = true;
    if (!(await this.validateFormByScope('customerPhone'))) {
      this.showPhoneUpdatePopup.loading = false;
      return;
    }
    if (!this.roDetails.customerLastName || this.roDetails.customerLastName == '') {
      this.showAlert(
        false,
        "Customer details not found."
      );
      this.showPhoneUpdatePopup.loading = false;
      return;
    }

    const model = {
      UpdateType: 'phone',
      CellPhone: this.customerUpdateViewModel.cellPhone,
      BusinessPhone: this.customerUpdateViewModel.businessPhone,
      PhoneNumber: this.customerUpdateViewModel.phoneNumber,
      CustomerNumber: this.roDetails.customerKey,
      FirstName: this.roDetails.customerFirstName,
      LastName: this.roDetails.customerLastName,
      TypeCode: this.roDetails.customerTypeCode,
    };
    try {
      await customerService.updateAsync(model);
      this.showAlert(
        true,
        this.$t('repairOrderDetails.alertCustomerPhoneUpdatedSuccessfully')
      );
      this.roDetails.cellPhone = model.CellPhone;
      this.roDetails.businessPhone = model.BusinessPhone;
      this.roDetails.homePhone = model.PhoneNumber;
    } finally {
      this.showPhoneUpdatePopup.loading = false;
      this.showPhoneUpdatePopup.model = false;
    }
  }

  public updatePayOverPhone() {
    this.flags.touchStarted = this.flags.payOverPhone;
    this.updateToolBar();
  }

  public showRoDeductiblePopup() {
    this.roDeductibleDialog.model = true;
  }

  public setVideoActions() {
    this.videoActions = [
      {
        type: 'button',
        icon: 'fas fa-check',
        title: 'Approve',
        color: 'green',
        visible: (model: any) => {
          if (model.isApprovalRequired) {
            return true;
          }
          return false;
        },
        action: (model: any, action: any) => {
          this.approveConfirmationDialog.model = true;
          this.approvalRequest.id = model.id;
          this.approvalRequest.isApproved = true;
        }
      },
      {
        type: 'button',
        icon: 'fas fa-ban',
        title: 'Reject',
        visible: (model: any) => {
          if (model.isApprovalRequired) {
            return true;
          }
          return false;
        },
        action: (model: any, action: any) => {
          // // this.approveAttachment(model, false);
          // this.approveConfirmationDialog.model = true;
          // this.approvalRequest.id = model.id;
          // this.approvalRequest.isApproved = false;
          this.rejectAttachment(model.id);
        }
      },
      {
        type: 'button',
        icon: 'fas fa-eye',
        title: 'View',
        action: (model: any, action: any) => {
          var uniqueId = Utils.newGuid();
          window.open(`${window.location.origin}/app/video/view/${uniqueId}/${model.attachmentExternalId}`);
          //alert(model.id + ' View Video');
          //this.approveAttachment(model, false);
        }
      }];
  }

  public async rejectAttachment(attachmentId: string): Promise<void> {
    try {
      await repairOrderService.rejectVideoClip(attachmentId);
      this.showAlert(true, 'Attachment Status Updated Successfully');
    } finally {

    }
  }


  public videolynkPopup: IDialogOption = {
    width: 700,
    title: 'Approve/Reject RO Video',
    model: false,
    loading: false,
    // onClose: (): void => {
    //   this.closevideoPopup();
    // },
  };

  public approveConfirmationDialog: IDialogOption = {
    width: 450,
    title: 'Confirm And Send',
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: 'Confirm',
      disable: false
    },
    onAction: (): void => {
      if (this.healthApproval.sendMode == '') {
        this.showAlert(false, 'Please Select One of the type to send Video');
        return;
      }
      this.approveAttachment();
    },
  };

  public confirmCreditCardFeesDialog: IDialogOption = {
    width: 450,
    title: 'Credit Card Fees',
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: 'Confirm',
      disable: false
    },
    onAction: (): void => {
      this.addCreditCardFees();
    }
  };

  public async approveAttachment(): Promise<void> {
    try {
      this.approveConfirmationDialog.loading = true;
      this.approveConfirmationDialog.action.disable = true;
      if (this.healthApproval.sendMode == 'Email') {
        if (this.videoLynk.email == '') {
          this.showAlert(false, 'Please Select Email.');
          return;
        }
        await repairOrderService.approveAndSendVideoClipEmail(this.approvalRequest.isApproved, this.approvalRequest.id, this.videoLynk.email);
      } else if (this.healthApproval.sendMode == 'Sms') {
        if (this.videoLynk.phone == '') {
          this.showAlert(false, 'Please Select Phone number.');
          return;
        }
        await repairOrderService.approveAndSendVideoClipSms(this.approvalRequest.isApproved, this.approvalRequest.id, this.videoLynk.phone);
      }
      this.showAlert(true, 'Approved Successfully');
    } finally {
      this.approvalRequest.id = '';
      this.approvalRequest.isApproved = false;

      this.approveConfirmationDialog.loading = false;
      this.approveConfirmationDialog.action.disable = false;
      this.approveConfirmationDialog.model = false;
      this.healthApproval.sendMode = '';
      this.videoLynk.email = '';
      this.videoLynk.phone = '';
    }
  }


  public async getCustomerDetail(customerKey): Promise<void> {
    var response = await repairOrderService.getCustomerDetails(customerKey);
    this.lstCustomerEmails = response.customerEmail;
    this.lstCustomerPhone = response.customerPhone;
  }

  public calculateCreditCardFee() {
    const totalDue = parseFloat(this.roDetails.totalDue);
    if (this.roDetails.isCreditCardFeeEnabled && this.roDetails.creditCardFeePercentage > 0) {

      const totalFee = totalDue * this.roDetails.creditCardFeePercentage / 100;
      this.creditCardTotalFeeWithouTax = totalFee ? Number(totalFee.toFixed(2)) : 0;
      if (this.roDetails.isCreditCardFeeTaxable) {
        this.creditCardTotalFee = totalFee + (totalFee * this.roDetails.creditCardTaxPercentage / 100);
      } else {
        this.creditCardTotalFee = totalFee;
      }
    }

    this.totalDueWithFee = Math.round((totalDue + this.creditCardTotalFee) * 100) / 100;
    this.displayTotalDueWithFee = Math.round((this.totalDueWithFee) * 100) / 100;
    this.displayTotalFee = Math.round((this.creditCardTotalFee) * 100) / 100;
  }

  public async openCreditCardFeeDialog() {
    this.confirmCreditCardFeesDialog.model = true;
  }

  public async addCreditCardFees() {

    if (this.creditCardTotalFeeWithouTax <= 0) {
      this.showAlert(false, 'Fees value should be greater than 0');
      this.confirmCreditCardFeesDialog.model = false;
      this.confirmCreditCardFeesDialog.loading = false;
      this.confirmCreditCardFeesDialog.action.disable = false;
      return;
    }

    this.confirmCreditCardFeesDialog.loading = true;
    this.confirmCreditCardFeesDialog.action.disable = true;
    try {
      var response = await repairOrderService.addRoCreditCardFees(this.roDetails.roNumber, this.creditCardTotalFeeWithouTax);

      if (response.status) {
        this.showAlert(
          response.status,
          response.status ? 'Credit Card Fees added successfully.' : 'Failed to Add Credit Card Fees.'
        );

        setTimeout(() => {
          if (response.status) {
            //window.location.reload();
            this.$router.go(0);
          }
        }, 2000);
      }
    }
    catch (e) { }
    finally {
      this.confirmCreditCardFeesDialog.model = false;
      this.confirmCreditCardFeesDialog.loading = false;
      this.confirmCreditCardFeesDialog.action.disable = false;
    }
  }

  public updateCloverDialog(cloverDialogVaue) {
    this.isCloverDialog = cloverDialogVaue;
  }
  public paymentOptions: IPaymentDialog = {
    id: "RoPaymentDetails",
    url: window.location.href,
    customerKey: this.roDetails.customerKey,
    vin: this.roDetails.vin,
    amount: Number(this.amountToBePaid),
    address: this.roDetails.customerStreetAddress1 + ' ' + this.roDetails.customerStreetAddress2,
    city: this.roDetails.customerCity,
    state: this.roDetails.customerState,
    zipcode: this.roDetails.customerZip,
    customerEmail: this.roDetails.customerEmail1,
    merchantEmail: this.roDetails.merchantEmail,
    recordKey: this.roDetails.roNumber,
    recordIdentifier: "RO",
    type: "0",
    isSendPaymentReceipt: this.isSendPaymentReceipt,
    isOverrideCCFeeApplied: this.isOverrideCCFeeApplied,
    bypassReason: this.bypassReason,
    isDeductiblePayment: this.isDeductiblePayment

  };
  public updatePaymentDialog(paymentDialogValue) {
    this.paymentDialog = paymentDialogValue;
  }
}
